webpackJsonp([191143899092530],{

/***/ 800:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(3);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Webpack = __webpack_require__(24);
	
	var _Webpack2 = _interopRequireDefault(_Webpack);
	
	var _Markdown = __webpack_require__(5);
	
	var _Markdown2 = _interopRequireDefault(_Markdown);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(
	    _Webpack2.default,
	    null,
	    _react2.default.createElement(
	      'h1',
	      null,
	      'Configure Basename'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Webpack is configured to serve the application from the root domain as the default, meaning that if you\'re application is hosted on ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'https://app.example.com'
	      ),
	      ', then the default assumes the application will be served from ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'https://app.example.com'
	      ),
	      '.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'That\'s what happens when you start the application using this command:'
	    ),
	    _react2.default.createElement(_Markdown2.default, { text: '\n      npm start\n      ' }),
	    _react2.default.createElement(
	      'p',
	      null,
	      'If you need to serve the application from nested URL, like ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'https://www.example.com/application/'
	      ),
	      ', then you\'ll need to specify a ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'basename'
	      ),
	      ' in order for Webpack to generate the correct URLs for your assets.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'To do that, start the application using this command, where ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'basename'
	      ),
	      ' is the URL path you want the application to be served from:'
	    ),
	    _react2.default.createElement(_Markdown2.default, { text: '\n      npm start --\n        --env.basename=/application\n      ' }),
	    _react2.default.createElement(
	      'p',
	      null,
	      'The command above would cause the development server to be served on port ',
	      _react2.default.createElement(
	        'code',
	        null,
	        '3001'
	      ),
	      ' instead.'
	    ),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Relevant Section'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'This section of the Webpack config that controls this behavior is shown below:'
	    ),
	    _react2.default.createElement(_Markdown2.default, { text: '\n      var BASENAME = env.basename || \'\';\n      ...\n      plugins: [\n        new webpack.DefinePlugin({\n          __BASENAME__: JSON.stringify(BASENAME),\n        }),\n        new HtmlWebpackPlugin({\n          publicPath: `${BASENAME}/`\n        }),\n      ],\n      ...\n      devServer: {\n        historyApiFallback: {\n          index: `${BASENAME}/index.html`,\n        }\n      }\n      ' })
	  );
	};
	
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-webpack-development-basename-js-aef6c8c55b9feb1b76cc.js